<app-breadcrumb [title]="'Regions'"></app-breadcrumb>
<div class="container-fluid">
  <div class="row">
    <div class="col">
      <div class="card mb-3">
        <div class="card-header">
          <div class="d-flex align-items-center justify-content-between">
            <h3 class="h6 fw-bold mb-0">{{ title }}</h3>
            <a routerLink="/admin/regions" class="btn btn-outline-primary">Cancel</a>
          </div>
        </div>
        <div class="card-body">
          <form [formGroup]="regionForm" (ngSubmit)="save()">
            <input type="hidden" formControlName="userId">
            <div class="row">
              <div class="col-md-4">
                <div class="form-group mb-3">
                  <label class="form-label" for="countryId">Country</label>
                  <select MyInput formControlName="countryId" class="form-control form-control-sm">
                    <option value="" selected>--SELECT--</option>
                    <option *ngFor="let item of countries" value="{{ item.value }}">{{ item.text }}
                    </option>
                  </select>
                  <my-error controlName="countryId" errorKey="required">country is required.</my-error>
                </div>
                <div class="form-group mb-3">
                  <label class="form-label" for="email">Email</label>
                  <input MyInput formControlName="email" class="form-control form-control-sm" />
                  <my-error controlName="email" errorKey="required">Email is required.</my-error>
                  <my-error controlName="email" errorKey="email">Email is not in valid format.</my-error>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group mb-3">
                  <label class="form-label" for="name">Name</label>
                  <input MyInput formControlName="name" class="form-control form-control-sm" />
                  <my-error controlName="name" errorKey="required">Name is required.</my-error>
                </div>
                <div class="form-group mb-3">
                  <label class="form-label" for="code">Code</label>
                  <input MyInput formControlName="code" class="form-control form-control-sm" />
                  <my-error controlName="code" errorKey="required">Code is required.</my-error>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group mb-3">
                  <label class="form-label" for="address">Address</label>
                  <textarea MyInput formControlName="address" class="form-control form-control-sm" rows="2"></textarea>
                  <my-error controlName="address" errorKey="required">Address is required.</my-error>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-4">
                <div class="form-group mb-3">
                  <label class="form-label" for="phone_1">Phone I</label>
                  <input MyInput formControlName="phone_1" class="form-control form-control-sm" />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group mb-3">
                  <label class="form-label" for="phone_2">Phone II</label>
                  <input MyInput formControlName="phone_2" class="form-control form-control-sm" />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group mb-3">
                  <label class="form-label" for="phone_3">Phone III</label>
                  <input MyInput formControlName="phone_3" class="form-control form-control-sm" />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-4">
                <div class="form-group mb-3">
                  <label class="form-label" for="email_1">Email I</label>
                  <input MyInput formControlName="email_1" class="form-control form-control-sm" />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group mb-3">
                  <label class="form-label" for="email_2">Email II</label>
                  <input MyInput formControlName="email_2" class="form-control form-control-sm" />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group mb-3">
                  <label class="form-label" for="email_3">Email III</label>
                  <input MyInput formControlName="email_3" class="form-control form-control-sm" />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-4">
                <div class="form-group mb-3">
                  <label class="form-label" for="fax_1">Fax I</label>
                  <input MyInput formControlName="email_1" class="form-control form-control-sm" />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group mb-3">
                  <label class="form-label" for="fax_2">Fax II</label>
                  <input MyInput formControlName="fax_2" class="form-control form-control-sm" />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group mb-3">
                  <label class="form-label" for="fax_3">Fax III</label>
                  <input MyInput formControlName="fax_3" class="form-control form-control-sm" />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="form-group mb-3">
                  <label class="form-label" for="assiCommName">Assi. Comm. Name</label>
                  <input MyInput formControlName="assiCommName" class="form-control form-control-sm" />
                </div>
              </div>
              <div class="col-md-6">
                <label class="form-label" for="assiCommSignId">Signature</label>
                <div class="row">
                  <div class="col-md-8">
                    <div class="form-file">
                      <input class="form-file-input" type="file" #inputDoc
                        (change)="handleFileInput($event.target.files);OnSubmit(inputDoc)">
                      <label class="form-file-label" for="customFile">
                        <span class="form-file-text">Choose file...</span>
                        <span class="form-file-button">Browse</span>
                      </label>
                    </div>
                    <my-error controlName="assiCommSignId" errorKey="required">Sign is required.</my-error>
                  </div>
                  <div class="col-md-4" *ngIf="region?.assiCommSign">
                    <img [src]="region?.assiCommSign.mediaUrl" class="avatar bg-transparent" />
                  </div>
                </div>
                <div id="progress-avatar" class="progress progress-xs" [class.fade]="!isProgress">
                  <div [style.width]="barWidth + '%'"
                    class="progress-bar progress-bar-striped progress-bar-animated bg-success" role="progressbar"
                    aria-valuemin="0" aria-valuemax="100"></div>
                </div>


              </div>
            </div>
            <div class="d-flex justify-content-end">
              <button class="btn btn-primary rounded-0 mr-2" [disabled]="!regionForm.valid || loading" type="submit">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="loading"></span>
                Submit
              </button>
              <button *ngIf="id" type="button" (click)="delete()" class="btn btn-danger rounded-0">Delete</button>
            </div>
          </form>

        </div>
      </div>

    </div>
  </div>
</div>